<template>
  <v-row>
    <v-col cols="12">
      <promo />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import Promo from 'Components/Promo/redeem/Promo'

export default {
  name: 'PromoView',
  data: () => ({
    loading: true
  }),
  components: { Promo },
  methods: {
    ...mapActions(['getPromo', 'reportError']),
    async loadPromo () {
      try {
        await this.getPromo(this.$route.params.promo_id)
      } catch (err) {
        this.reportError(err)
        await this.$router.push('/')
      }
    }
  },
  mounted () {
    this.loadPromo()
  },
}
</script>
